/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
// css
import { ListView } from 'antd-mobile'
import _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { UserBlockListWrap } from '@views/MyPage/index.style'
import { Button } from '@styles/button.style'
import DialogUtils from '@utils/dialog-utils'
import PopupUtils from '@utils/popup-utils'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { Schema$CommunicationBlockUserInfo } from '@interface/common'
import { isCustomProfileImg } from '@utils/utils'
import AdvImg from '@components/AdvImg'

const ListViewStyle = css`
  background: #ddd;
  height: 100%;
`

export const UserBlockList: React.FC = observer(() => {
  const { componentStore } = useRootStore()
  const { communicationBlockUserInfos, communicationBlockHasMore } = componentStore
  const [isLoading, setIsLoading] = useState(false)

  const fetch = async (reset = false) => {
    try {
      setIsLoading(true)
      await componentStore.fetchCommunicationBlockUserInfos(reset)
    } catch(err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useOnMount(() => {
    fetch(true).catch(console.error)
  })

  useOnUnmount(() => {
    componentStore.resetCommunicationBlockUserInfos()
  })

  useEffect(() => {
    PopupUtils.changePopupTitle('user-block-list-view', `차단관리 ${communicationBlockUserInfos.length}`)
  }, [communicationBlockUserInfos])

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  const endReachedHandler = () => {
    if (isLoading || !communicationBlockHasMore) {
      return
    }

    fetch().catch(console.error)
  }

  const renderTitle = (): React.ReactElement => {
    return <Fragment/>
  }

  const onClickBlockUser = (
    userPromiseId: string,
    userNick: string,
    userProfileImg: string,
  ): void => {
    DialogUtils.showUserBlock(userPromiseId, userNick, userProfileImg)
  }

  const onClickUnBlockUser = (userPromiseId: string): void => {
    DialogUtils.showUserUnBlock(userPromiseId)
  }

  const renderRow = (blockUserInfo: Schema$CommunicationBlockUserInfo) => {
    const { userPromiseId, userNick, userProfileImg } = blockUserInfo

    return (
      <UserBlockListWrap key={userPromiseId}>
        <div className="profile-img-wrap lhn34">
          {isCustomProfileImg(userProfileImg) ?
            (<AdvImg src={userProfileImg} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img" loading="lazy"/>)
            :
            (<AdvImg src={userProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img" loading="lazy"/>)
          }
        </div>
        <p className="nick-name">{userNick}</p>
        <Button TP className="block-btn" onClick={() => {
          onClickBlockUser(userPromiseId, userNick, userProfileImg)
        }}>설정</Button>
        <Button TP className="block-btn clear" onClick={() => { onClickUnBlockUser(userPromiseId) }}>해제</Button>
      </UserBlockListWrap>
    )
  }


  const renderFooter = () => {
    let footer
    if (_.size(communicationBlockUserInfos) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.USER_BLOCK_LIST}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }


  return (
    <ListView
      className="user-block-list-view"
      dataSource={dataSource.cloneWithRows(communicationBlockUserInfos)}
      renderHeader={renderTitle}
      renderRow={renderRow}
      renderFooter={renderFooter}
      onEndReached={endReachedHandler}
      scrollRenderAheadDistance={500}
      onEndReachedThreshold={10}
      pageSize={20}
      initialListSize={20}
      css={ListViewStyle}
    />
  )
})
